import { Component, ViewChild } from '@angular/core';
import { AppService } from '../app.service';
import { MessageService, SelectItem } from 'primeng/api';
import { ContentType, SeverityEnum, TableColumn, ToastMsg } from 'src/model/page';
import {JsonTongue, JsonTongueOrderList, TongueLocation, TongueType} from 'src/model/dto';
import { TongueDialogComponent } from './tongue-dialog/tongue-dialog.component';

@Component({
  selector: 'app-tongue-list',
  templateUrl: './tongue-list.component.html',
  styleUrls: ['./tongue-list.component.scss']
})
export class TongueListComponent {
  @ViewChild(TongueDialogComponent) tongueDialog: TongueDialogComponent;
  typeOptions: SelectItem[];
  cols: TableColumn[];
  selectedType: number = 1;
  tongues: JsonTongue[] = [];
  editedTongue: JsonTongue;
  isEditOrder = false;

  constructor(
    private appService: AppService,
    private msgService: MessageService
  ) {}

  ngOnInit(): void {
    this.typeOptions = [
      {label: 'Shape', value: 1},
      {label: 'Color', value: 2},
      {label: 'Coating', value: 3}
    ];
    this.cols = [
      {header: 'Icon', field: 'imageUrl'},
      {header: 'Name', field: 'name'},
      {header: 'Pattern', field: 'diagnosisList'},
      {header: 'Status', field: 'status'}
    ];
    this.loadData();
  }

  loadData(): void {
    const data = {
      type: this.selectedType,
      filterDisabled: 0,
      includeIcon: 1
    }
    this.appService.get('data', 'getTongues', data).subscribe((res: JsonTongue[]) => {
      this.tongues = res;
    });
  }

  onSelect(tongue: JsonTongue): void {
    this.editedTongue = tongue;
    this.tongueDialog.show(true);
  }

  onNew(): void {
    const maxOrder = this.tongues.map(t => t.displayOrder).reduce((res, cur) => res >= cur? res: cur, 0);
    this.editedTongue = {
      id: 0,
      name: '',
      chineseName: '',
      chineseDescription: '',
      type: this.selectedType,
      diagnosisList: [],
      displayOrder: maxOrder + 1,
      modTime: null,
      status: 1,
      imageUrl: '',
      segment: ''
    };
    if (this.editedTongue.type === TongueType.Color) {
      const locationValues = Object.values(TongueLocation).filter(v => typeof v === 'number') as number[];
      for (const location of locationValues) {
        this.editedTongue.diagnosisList.push({
          id: 0,
          location: location,
          pattern: '',
          symptomsMale: '',
          symptomsFemale: '',
          recommendation: '',
          chinesePattern: '',
          chineseSymptomsMale: '',
          chineseSymptomsFemale: '',
          chineseRecommendation: '',
          fiveElements: []
        });
      }
    } else {
      this.editedTongue.diagnosisList.push({
        id: 0,
        location: 0,
        pattern: '',
        symptomsMale: '',
        symptomsFemale: '',
        recommendation: '',
        chinesePattern: '',
        chineseSymptomsMale: '',
        chineseSymptomsFemale: '',
        chineseRecommendation: '',
        fiveElements: []
      });
    }
    console.log(this.editedTongue);
    this.tongueDialog.show(true);
  }

  onSave(tongue: JsonTongue): void {
    this.loadData();
  }

  onEditOrder(): void {
    this.isEditOrder = true;
  }

  onSaveOrder(): void {
    const data: JsonTongueOrderList = {
      type: this.selectedType,
      ids: this.tongues.map(tongue => tongue.id)
    };
    this.appService.postBody('admin', 'updateTongueOrder', JSON.stringify(data), ContentType.json).subscribe((res: JsonTongue[]) => {
      this.tongues = res;
      this.isEditOrder = false;
      this.msgService.add(new ToastMsg(SeverityEnum.success, 'Succeed to modify the order', ''));
    });
  }
}
